export const participiants = {
  participiants: {
    shape:
      '    <path fill="#000" fill-opacity=".51" d="M9.8 21.5V8.325a5.211 5.211 0 0 1-3.1-1.788A5.85 5.85 0 0 1 5.3 3.2h1c.133 1.2.625 2.204 1.475 3.013.85.808 1.842 1.212 2.975 1.212h2.5c.383 0 .708.054.975.163.267.108.533.304.8.587l4.25 4.225-.7.725L14.2 8.75V21.5h-1v-5.875h-2.4V21.5h-1ZM12 5.775c-.467 0-.867-.167-1.2-.5a1.637 1.637 0 0 1-.5-1.2c0-.467.167-.867.5-1.2.333-.333.733-.5 1.2-.5.467 0 .867.167 1.2.5.333.333.5.733.5 1.2 0 .467-.167.867-.5 1.2-.333.333-.733.5-1.2.5Z"/>',
    viewBox: [0, 0, 24, 24],
  },
};
